
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  AI,
  Answer,
  AIGroup,
  Candidate,
  CandidateResult,
  ColorQuestionAnswerResult,
  ReportShowConfigV5Item
} from "@/lib/model/exam/result";
import TooltipMaterials from "@/components/tooltip/moduleResult.vue";
import CandidateAnswerSection from "@/views/paper/components/candidate-answer-section-module.vue";
import SvgImgV3 from "@/components/videoPaly/video-play-v3.vue";
import { Question } from "@/lib/model/question/question";
import { getDimensionColor } from "@/lib/dimension/dimension-color";
import AudioStyle from "@/components/videoPaly/audioStyle.vue";

@Component({
  components: {
    TooltipMaterials,
    CandidateAnswerSection,
    SvgImgV3,
    AudioStyle
  }
})
export default class PaperResultReport extends Vue {
  @Prop() index!: number;
  @Prop({ default: () => new Candidate() }) candidate!: Candidate;
  @Prop({ default: () => new CandidateResult() }) all!: CandidateResult;
  @Prop({ default: false }) pdfIng!: boolean;
  @Prop({ default: () => new ReportShowConfigV5Item() })
  option!: ReportShowConfigV5Item;

  connectCode = "";
  showAiQuestion = true; //ai回答记录展开收起
  questionIndexAppendIndex = {}; //正在播放的回答视频 { 题号: 追问index }
  playTime = 0; // 记录答案播放进度
  lastPlayVideoIndex = -1; // 最后播放的视频序号
  highLightIndex = -1;

  get isGroup() {
    return this.all.configGroup.showType === 1;
  }

  get questionList() {
    return this.all.questionList.filter(q => [1, 7, 6, 8, 5].includes(q.type));
  }

  get answerList() {
    return this.all.answerList.filter(a => [1, 7, 6, 8, 5].includes(a.type));
  }

  get isStudent() {
    return this.all.configGroup.suggestType === 2;
  }

  //是否展示参考答案
  get showAnswerFlag() {
    //非维度组  需求变更：旧版不展示参考答案
    const p1 = this.all.configGroup.showType !== 1 && false;
    //是维度组 且 开启展示
    const p2 =
      this.all.configGroup.showType === 1 &&
      this.all.configGroup.showReferenceAnswer === 1;
    console.log(this.option);
    return p1 || p2;
  }

  created() {
    //
  }

  //
  mounted() {
    this.connectCode = this.$route.query.connectCode as string;
    // this.isStudent = String(this.$route.query.ver || "") === "1";
    document.addEventListener("fullscreenchange", this.checkFullscreen);
  }
  //全屏视频修改填充样式
  isVideoFullscreen = false;
  get objectFit() {
    return this.isVideoFullscreen ? "contain" : "cover";
  }
  checkFullscreen() {
    this.isVideoFullscreen =
      document.fullscreenElement !== null &&
      document.fullscreenElement.tagName === "VIDEO";
  }
  beforeDestroy() {
    document.removeEventListener("fullscreenchange", this.checkFullscreen);
  }

  // tooltip音频播放
  playAudioDesc(q: Question) {
    // 存在音频列表
    const audioList: HTMLAudioElement[] = [];
    // 先停止其他音频
    const audioElements = document.querySelectorAll("audio");
    audioElements.forEach((audioElement: HTMLAudioElement, i: number) => {
      if (
        !audioList.find(
          (audio: HTMLAudioElement) => audio.id === audioElement.id
        )
      ) {
        audioList.push(audioElement);
      }
      audioElement.pause();
    });
    this.stopAllMp3StatusIcon();

    const currentAudio = audioList.find(
      (audio: HTMLAudioElement) => audio.id === `player${q.questionId}`
    );
    if (currentAudio) {
      currentAudio.play();
    } else {
      const audio = document.createElement("audio") as HTMLAudioElement;
      audio.id = `player${q.questionId}`;
      audio.src = q.audioDescUrl;
      audio.addEventListener("ended", () => {
        this.stopAllMp3StatusIcon();
      });
      document.body.appendChild(audio);
      audio.play();
    }
  }
  stopAllMp3StatusIcon() {
    const mp3Player = this.$refs["tooltipMaterials"] as [];
    if (mp3Player?.length) {
      mp3Player.forEach((player: any) => {
        player.isPlaying = false;
      });
    }
  }

  timeupdate({ target }: Event, answerIndex: number) {
    this.playTime = (target as HTMLMediaElement).currentTime * 1000;
    this.lastPlayVideoIndex = answerIndex;
  }

  onClickAsrItem(data: {
    answerIndex: number;
    appendIndex: number;
    time: number;
  }) {
    const refName = "PCvideo-" + data.answerIndex;
    this.questionIndexAppendIndex[data.answerIndex] = data.appendIndex;
    try {
      // 找到this.$refs中所有PCvideo-开头的元素，除要播放的以外的全部停止
      for (const key in this.$refs) {
        const element = this.$refs[key];
        if (key.indexOf("PCvideo-") === 0 && key !== refName) {
          element[0].pause();
        }
      }
      //当前题目播放器
      const videoPalyer = this.$refs[refName][0];

      if (!videoPalyer) return;
      //播放地址 默认主回答
      let videoUrl = this.all.answerList[data.answerIndex].aliyunVideoUrl;
      if (data.appendIndex > -1) {
        //播放地址 切换追问
        videoUrl = this.all.answerList[data.answerIndex].videoAppendAnswerList[
          data.appendIndex
        ].videoUrl;
      }
      videoPalyer.src = videoUrl;
      videoPalyer.poster = [
        "vod2.hina.com",
        "oss.hina.com",
        "vod.hina.com"
      ].includes(videoUrl)
        ? videoUrl + "?x-oss-process=video/snapshot,t_2000,f_jpg,ar_auto"
        : "";
      videoPalyer.currentTime = data.time / 1000 + 0.01; // 这个地方+0.01防止上一句话闪一下
      videoPalyer.play();
    } catch (e) {
      console.log(e);
    }
  }
  // 自动播放下一个追问
  onEnded(questionIndex: number) {
    const questionLen = this.all.answerList[questionIndex].videoAppendAnswerList
      .length;

    if (!questionLen) return;

    const appendIndex = this.questionIndexAppendIndex?.[questionIndex] ?? -1;

    if (appendIndex < questionLen - 1) {
      this.onClickAsrItem({
        answerIndex: questionIndex,
        appendIndex: appendIndex + 1,
        time: 0
      });
    }
  }
  //前一个追问
  preAppend(questionIndex: number) {
    const appendIndex = this.questionIndexAppendIndex?.[questionIndex] ?? -1;

    if (appendIndex > -1) {
      this.onClickAsrItem({
        answerIndex: questionIndex,
        appendIndex: appendIndex - 1,
        time: 0
      });
    }
  }
  //下一个追问
  nextAppend(questionIndex: number) {
    const appendIndex = this.questionIndexAppendIndex?.[questionIndex] ?? -1;
    const questionLen = this.all.answerList[questionIndex].videoAppendAnswerList
      .length;

    if (appendIndex < questionLen - 1) {
      this.onClickAsrItem({
        answerIndex: questionIndex,
        appendIndex: appendIndex + 1,
        time: 0
      });
    }
  }

  getBlankCandidateAnswer(q: number) {
    let res = ``;
    const list = this.all.answerList[q].blanks;
    const isRight = this.all.answerList[q].blanksIsRight;
    list.forEach((d: any, i: number) => {
      res += `${i + 1}.（${d}）【${isRight[i] ? "正确" : "错误"}】；`;
    });
    return res;
  }

  getBlankAnswer(q: number) {
    const list = this.all.questionList[q].blankQuestionConfig.answerList;
    let res = ``;
    list.forEach((d: any, i: number) => {
      res += `${i + 1}.（${d.words}）；`;
    });
    return res;
  }

  getAIComment(answer: any) {
    return answer.aiComment.replaceAll("\n", "<br/>");
  }

  // mp3不展示居中播放按钮
  isShowSvg(val: string) {
    return (
      val &&
      String(val)
        .substr(-3, 3)
        .toLowerCase() !== "mp3"
    );
  }
}
